import { reactive, ref } from "vue";
import { queryModelList } from "@/api/model";

export default function useModelTable() {
  // 搜索条件ref
  const searchRef = ref(null);

  // 搜索条件
  const searchData = reactive({
    processKey: null,
    systemId: null,
    processName: null,
    state: null,
  });

  // 表格列配置
  const columns = ref([
    {
      label: "流程key",
      prop: "processKey",
      fixed: true,
    },
    {
      label: "所属系统",
      prop: "serviceCodeText",
    },
    {
      label: "模型名称",
      prop: "processName",
    },
    {
      label: "表单key",
      prop: "formKey",
    },
    {
      label: "状态",
      prop: "state",
    },
    {
      label: "备注",
      prop: "remark",
    },
    {
      label: "是否子流程",
      prop: "subFlag",
    },
  ]);

  // 表格loading
  const tableLoading = ref(false);

  // 表格数据
  const tableData = ref([]);

  // 分页数据
  const pages = reactive({
    page: 1,
    limit: 10,
    total: 0,
  });

  // 获取数据
  const getList = () => {
    tableLoading.value = true;
    queryModelList({
      ...searchData,
      page: pages.page,
    })
      .then((res) => {
        tableData.value = res.data.records || [];
        pages.total = res.data.total;
      })
      .finally(() => {
        tableLoading.value = false;
      });
  };

  // 重置按钮
  const handleReset = () => {
    searchRef.value?.resetFields();
    getList();
  };
  return {
    searchRef,
    searchData,
    columns,
    tableLoading,
    tableData,
    pages,
    getList,
    handleReset,
  };
}
